import {useEffect} from "react";
import {useAtomValue} from "jotai";
import {impersonationAtom} from "../store/impersonationStore";
import {userImpersonation} from "../services/baseService";

/**
 * Hook sets value in userImpersonation closure, used by baseService to set HTTP impersonation header
 */
export const useSetImpersonation = () => {
    const impersonation = useAtomValue(impersonationAtom);

    useEffect(() => {
        userImpersonation.set(impersonation);
    }, [impersonation]);
};
